<template>
    <div>
        <froala
            v-show="launchFroala"
            :tag="'textarea'"
            :config="froalaConfig"
            v-model.trim="currentFacility.content_about"
            id="facility-about"
        />
    </div>
</template>

<script>
export default {
  props: {
    currentFacility: {
      type: Object
    },
    froalaConfig: {
      type: Object
    },
    launchFroala: {
      type: Boolean,
      default: false
    },
    section: {
      type: Object
    }
  }
};
</script>

<style>
    .froala {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
